import * as React from 'react';

type HeadsetSvgProps = React.SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
};

const HeadsetSmallSvg: React.FC<HeadsetSvgProps> = ({ width = 16, height = 16, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 14" fill="none" {...props}>
    <path
      d="M10.6667 9.33073V11.3307C10.6667 11.6974 10.3667 11.9974 10 11.9974H9.33333V9.33073H10.6667ZM2.66667 9.33073V11.9974H2C1.63333 11.9974 1.33333 11.6974 1.33333 11.3307V9.33073H2.66667ZM6 0.664062C2.68667 0.664062 0 3.35073 0 6.66406V11.3307C0 12.4374 0.893333 13.3307 2 13.3307H4V7.9974H1.33333V6.66406C1.33333 4.08406 3.42 1.9974 6 1.9974C8.58 1.9974 10.6667 4.08406 10.6667 6.66406V7.9974H8V13.3307H10C11.1067 13.3307 12 12.4374 12 11.3307V6.66406C12 3.35073 9.31333 0.664062 6 0.664062Z"
      fill="white"
    />
  </svg>
);
export default HeadsetSmallSvg;
